import React, { useState, useRef, useEffect } from 'react';
import Banner from './Header/Banner';

function Layout(props) {
    const [dimensions, setDimensions] = useState({ x: window.innerWidth, y: window.innerHeight });
    const [scrollDepth, setScrollDepth] = useState(0);
    const contentEl = useRef(null);
    useEffect(() => {
        contentEl.current.addEventListener('scroll', onScroll);
        window.addEventListener('resize', onResize);
        return () => {
            contentEl.current.removeEventListener('scroll', onScroll);

        };
    }, []);

    const onResize = () => {
        setDimensions({ x: window.innerWidth, y: window.innerHeight });
    };

    const onScroll = () => {
        setScrollDepth(contentEl.current.scrollTop);
    };

    const scrollToTop = () => {
        contentEl.current.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const scrollToClass = scrollDepth < 30 ? 'scroll-to-top action-icon' : 'scroll-to-top action-icon active';

    return (
        <div id="layout">
            <Banner dimensions={dimensions}/>
            <div className="content" ref={contentEl}>
                {props.children}
                <div className={scrollToClass} onClick={scrollToTop}>
                    <i className="fas fa-angle-double-up"></i>
                </div>
            </div>
        </div>
    );
}

export default Layout;
